(function () {
  const BENEFITS = [
    '25 % popusta na prvu narudžbu',
    '20 % popusta za sve sljedeće narudžbe',
    'Pretplatu možete u bilo kojem trenutku privremeno pauzirati, promijeniti ili otkazati',
    'Kod narudžbe 3 ili više kolagena - poštarina je BESPLATNA',
  ];

  const TRANSLATIONS = {
    'One-time purchase': 'JEDNOKRATNA KUPNJA',
    'Auto-renews, skip or cancel anytime.': '',
    Subscription: 'Pretplata',
  };

  const BUNDLES = [
    { qty: 1, discount: null },
    { qty: 5, discount: 5 },
    { qty: 10, discount: 10 },
    { qty: 20, discount: 20 },
  ];

  function parseDeliveryOption(text) {
    const match = text.match(/Deliver every (\d+)\s*(week|weeks|day|days),\s*(\d+)%\s*off/i);
    if (!match) return { label: text, discount: null };

    const amount = parseInt(match[1], 10);
    const unit = match[2].toLowerCase();
    const discount = parseInt(match[3], 10);
    const isWeek = unit.startsWith('week');
    const unitHr = isWeek
      ? amount === 1
        ? 'tjedan'
        : amount < 5
          ? 'tjedna'
          : 'tjedana'
      : amount === 1
        ? 'dan'
        : 'dana';

    const prefix = isWeek && amount > 1 ? 'Dostava svaka' : 'Dostava svakih';
    return {
      label: `${prefix} ${amount} ${unitHr}`,
      discount,
    };
  }

  function formatPriceElement(el, salePrice, comparePrice) {
    if (!el || !salePrice) return;

    el.classList.remove('shopify_subscriptions_app_block--hidden');
    el.removeAttribute('aria-hidden');

    if (comparePrice && comparePrice !== salePrice) {
      el.innerHTML =
        '<span class="subs-compare-price">' +
        comparePrice +
        '</span><span class="subs-sale-price">' +
        salePrice +
        '</span>';
    } else {
      el.innerHTML = '<span class="subs-sale-price">' + salePrice + '</span>';
    }
  }

  function translateText(node) {
    if (!node) return;
    const text = node.textContent.trim();
    if (TRANSLATIONS[text] !== undefined) {
      node.textContent = TRANSLATIONS[text];
    }
  }

  function scrollToFaq(event) {
    event.preventDefault();
    const faqSection =
      document.querySelector('[id*="collapsible_content"]') ||
      document.querySelector('.collapsible-content') ||
      document.querySelector('section.collapsible-content-section');

    if (faqSection) {
      faqSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function addBenefitsList(subscriptionGroup) {
    if (subscriptionGroup.querySelector('.subs-benefits-list')) return;

    const list = document.createElement('ul');
    list.className = 'subs-benefits-list';

    BENEFITS.forEach(function (text) {
      const li = document.createElement('li');
      li.textContent = text;
      list.appendChild(li);
    });

    const faqLi = document.createElement('li');
    faqLi.innerHTML =
      'Više informacija o pretplati možete pročitati u <a href="#" class="subs-faq-link">Često postavljana pitanja</a>';
    list.appendChild(faqLi);

    const dropdown = subscriptionGroup.querySelector('.group_dropdown');
    if (dropdown) {
      dropdown.closest('.subs-dropdown-wrapper')?.after(list);
    } else {
      subscriptionGroup.appendChild(list);
    }

    const faqLink = list.querySelector('.subs-faq-link');
    if (faqLink) faqLink.addEventListener('click', scrollToFaq);
  }

  function wrapDropdown(select) {
    if (select.parentElement?.classList.contains('subs-dropdown-wrapper')) return select.parentElement;

    const wrapper = document.createElement('div');
    wrapper.className = 'subs-dropdown-wrapper';

    const badge = document.createElement('span');
    badge.className = 'subs-discount-badge';
    badge.setAttribute('aria-hidden', 'true');

    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);
    wrapper.appendChild(badge);

    return wrapper;
  }

  function translateDropdownOptions(select) {
    const wrapper = wrapDropdown(select);
    const badge = wrapper.querySelector('.subs-discount-badge');

    Array.from(select.options).forEach(function (option) {
      const parsed = parseDeliveryOption(option.textContent.trim());
      option.textContent = parsed.label;
      if (parsed.discount !== null) {
        option.dataset.discount = String(parsed.discount);
      }
    });

    function updateBadge() {
      const selected = select.options[select.selectedIndex];
      const discount = selected?.dataset.discount;
      if (badge) {
        badge.textContent = discount ? '-' + discount + '%' : '';
        badge.style.display = discount ? '' : 'none';
      }
    }

    select.removeEventListener('change', select._subsBadgeHandler);
    select._subsBadgeHandler = updateBadge;
    select.addEventListener('change', updateBadge);
    updateBadge();
  }

  function updateSubscriptionPrice(subscriptionGroup) {
    const priceEl = subscriptionGroup.querySelector('.allocation_price, .in_widget_price');
    const select = subscriptionGroup.querySelector('.group_dropdown');
    const checkedRadio = subscriptionGroup.querySelector('input[type="radio"]:checked');

    let salePrice = '';
    let comparePrice = '';

    if (select) {
      const selected = select.options[select.selectedIndex];
      salePrice = selected?.dataset.variantPrice || '';
      comparePrice = selected?.dataset.variantCompareAtPrice || '';
    }

    if (!salePrice && checkedRadio) {
      salePrice = checkedRadio.dataset.variantPrice || '';
      comparePrice = checkedRadio.dataset.variantCompareAtPrice || '';
    }

    formatPriceElement(priceEl, salePrice, comparePrice);
  }

  function updateOneTimePrice(oneTimeGroup) {
    const priceEl = oneTimeGroup.querySelector('.in_widget_price');
    const radio = oneTimeGroup.querySelector('[data-radio-type="one_time_purchase"]');
    const salePrice = radio?.dataset.variantPrice || priceEl?.textContent.trim();
    formatPriceElement(priceEl, salePrice, '');
  }

  function getProductImage(fieldset) {
    const section = fieldset.closest('[id^="MainProduct"]');
    if (section?.dataset.productImage) return section.dataset.productImage;

    const pageImg = document.querySelector(
      '.product__media img, .product-media-container img, [data-media-id] img'
    );
    return pageImg?.src || pageImg?.currentSrc || '';
  }

  function getQuantityInput(fieldset) {
    const section = fieldset.closest('[id^="MainProduct"]');
    return section?.querySelector('.quantity-input') || document.querySelector('.quantity-input');
  }

  function setQuantity(fieldset, qty) {
    const input = getQuantityInput(fieldset);
    if (!input) return;

    const min = parseInt(input.min, 10) || 1;
    const max = input.max ? parseInt(input.max, 10) : null;
    let value = qty;

    if (value < min) value = min;
    if (max !== null && value > max) value = max;

    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));

    const quantityInput = input.closest('quantity-input');
    if (quantityInput?.validateQtyRules) quantityInput.validateQtyRules();
  }

  function syncBundleSelection(fieldset, picker) {
    const input = getQuantityInput(fieldset);
    const currentQty = input ? parseInt(input.value, 10) : 1;

    picker.querySelectorAll('.subs-bundle-card').forEach(function (card) {
      const cardQty = parseInt(card.dataset.qty, 10);
      card.classList.toggle('is-selected', cardQty === currentQty);
      card.setAttribute('aria-pressed', cardQty === currentQty ? 'true' : 'false');
    });
  }

  function buildBundleImages(container, count, imageUrl) {
    container.innerHTML = '';
    container.dataset.count = String(count);

    if (!imageUrl) return;

    for (let i = 0; i < count; i++) {
      const img = document.createElement('img');
      img.src = imageUrl;
      img.alt = '';
      img.loading = 'lazy';
      container.appendChild(img);
    }
  }

  function toggleBundleVisibility(fieldset, picker) {
    const oneTimeRadio = fieldset.querySelector(
      'input[data-radio-type="one_time_purchase"]:checked'
    );
    const isOneTime = Boolean(oneTimeRadio);

    if (isOneTime) {
      picker.hidden = false;
      syncBundleSelection(fieldset, picker);
    } else {
      picker.hidden = true;
    }
  }

  function addBundlePicker(fieldset, oneTimeGroup) {
    if (oneTimeGroup.querySelector('.subs-bundle-picker')) return;

    const picker = document.createElement('div');
    picker.className = 'subs-bundle-picker';
    picker.hidden = true;

    const grid = document.createElement('div');
    grid.className = 'subs-bundle-grid';
    picker.appendChild(grid);

    const imageUrl = getProductImage(fieldset);

    BUNDLES.forEach(function (bundle) {
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'subs-bundle-card';
      card.dataset.qty = String(bundle.qty);
      card.setAttribute('aria-pressed', 'false');
      card.setAttribute(
        'aria-label',
        bundle.qty + ' komada' + (bundle.discount ? ', ušteda ' + bundle.discount + '%' : '')
      );

      if (bundle.discount) {
        const badge = document.createElement('span');
        badge.className = 'subs-bundle-card__badge';
        badge.textContent = 'Uštedi ' + bundle.discount + '%';
        card.appendChild(badge);
      }

      const images = document.createElement('div');
      images.className = 'subs-bundle-card__images';
      buildBundleImages(images, bundle.qty, imageUrl);
      card.appendChild(images);

      const label = document.createElement('span');
      label.className = 'subs-bundle-card__label';
      label.textContent = bundle.qty + ' kom.';
      card.appendChild(label);

      card.addEventListener('click', function () {
        const oneTimeRadio = fieldset.querySelector('input[data-radio-type="one_time_purchase"]');
        if (oneTimeRadio && !oneTimeRadio.checked) {
          oneTimeRadio.checked = true;
          oneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }

        setQuantity(fieldset, bundle.qty);
        syncBundleSelection(fieldset, picker);
      });

      grid.appendChild(card);
    });

    const wrapper = oneTimeGroup.querySelector('.title_and_price_wrapper');
    if (wrapper) {
      wrapper.after(picker);
    } else {
      oneTimeGroup.appendChild(picker);
    }

    fieldset.querySelectorAll('input[name^="purchaseOption"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        toggleBundleVisibility(fieldset, picker);
      });
    });

    const quantityInput = getQuantityInput(fieldset);
    if (quantityInput) {
      quantityInput.addEventListener('change', function () {
        if (!picker.hidden) syncBundleSelection(fieldset, picker);
      });
    }

    toggleBundleVisibility(fieldset, picker);
  }

  function reorderGroups(planCard) {
    const groups = Array.from(planCard.querySelectorAll('.subscription_group'));
    const subscriptionGroup = groups.find(function (g) {
      return g.querySelector('.group_dropdown, [data-radio-type="selling_plan_group"]');
    });
    const oneTimeGroup = groups.find(function (g) {
      return g.querySelector('[data-radio-type="one_time_purchase"]');
    });

    if (subscriptionGroup && oneTimeGroup && subscriptionGroup !== groups[0]) {
      planCard.insertBefore(subscriptionGroup, oneTimeGroup);
    }

    return { subscriptionGroup, oneTimeGroup };
  }

  function translateAriaLabels(fieldset) {
    fieldset.querySelectorAll('input[type="radio"], select.group_dropdown').forEach(function (el) {
      const label = el.getAttribute('aria-label');
      if (!label) return;

      el.setAttribute(
        'aria-label',
        label
          .replace(/One-time purchase/gi, 'Jednokratna kupnja')
          .replace(/Deliver every/gi, 'Dostava svakih')
          .replace(/weeks/gi, 'tjedana')
          .replace(/week/gi, 'tjedan')
          .replace(/days/gi, 'dana')
          .replace(/day/gi, 'dan')
          .replace(/off\./gi, 'popusta.')
          .replace(/(\d+)% off/gi, '$1% popusta')
          .replace(/Product price/gi, 'Cijena proizvoda')
      );
    });
  }

  function enhanceFieldset(fieldset) {
    const planCard = fieldset.querySelector('.plan_card');
    if (!planCard || planCard.dataset.subsEnhanced === 'true') return;
    planCard.dataset.subsEnhanced = 'true';

    const { subscriptionGroup, oneTimeGroup } = reorderGroups(planCard);

    if (oneTimeGroup) {
      const label = oneTimeGroup.querySelector('.one_time_purchase_option_app_block > span');
      translateText(label);
      updateOneTimePrice(oneTimeGroup);
      addBundlePicker(fieldset, oneTimeGroup);
    }

    if (subscriptionGroup) {
      const groupName = subscriptionGroup.querySelector('.group_name');
      if (groupName) groupName.textContent = 'PRETPLATA';

      const subRadio = subscriptionGroup.querySelector('input[data-radio-type="selling_plan_group"]');
      const oneTimeRadio = oneTimeGroup?.querySelector('input[data-radio-type="one_time_purchase"]');
      if (subRadio && oneTimeRadio?.checked) {
        oneTimeRadio.checked = false;
        subRadio.checked = true;
        subRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const select = subscriptionGroup.querySelector('.group_dropdown');
      if (select) translateDropdownOptions(select);

      updateSubscriptionPrice(subscriptionGroup);
      addBenefitsList(subscriptionGroup);

      if (select) {
        select.addEventListener('change', function () {
          updateSubscriptionPrice(subscriptionGroup);
        });
      }
    }

    const policy = fieldset.querySelector('.shopify_subscriptions_app_policy');
    if (policy) policy.style.display = 'none';

    const badgeText = fieldset.querySelector('#subscriptions_badge_text');
    if (badgeText) badgeText.textContent = 'Pretplata';

    translateAriaLabels(fieldset);
  }

  function init() {
    document.querySelectorAll('.shopify_subscriptions_fieldset').forEach(enhanceFieldset);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches?.('.shopify_subscriptions_fieldset')) {
          enhanceFieldset(node);
        } else {
          node.querySelectorAll?.('.shopify_subscriptions_fieldset').forEach(enhanceFieldset);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
